import React from 'react';
import { connect } from 'shalala';

import 'react-bootstrap-typeahead/css/Typeahead.css';

import { useStore } from '../../../store';
import AvatarLetter from '../../../facturotopia/avatar-letter/AvatarLetter';
import FaAsyncTypeahead from '../../../facturotopia/fa-typahead/FaAsyncTypeahead';

class EmisorSuggestionsList extends React.Component {
  state = {
    isLoading: false,
    options: [],
    query: '',
  };

  handleOnSelect = (item) => {
    this.props.onSelect(item);
  };

  render() {
    const { autoFocus = false, suggestions, suggestionsActions } = this.props;
    const { data } = suggestions;

    return (
      <FaAsyncTypeahead
        id="async-pagination-emisores"
        paginate
        autoFocus={autoFocus}
        minLength={2}
        placeholder="Buscar emisor..."
        paginationText="Mostrar más..."
        searchText="Buscando..."
        labelKey="rfc"
        options={data}
        container={{ state: suggestions, ...suggestionsActions }}
        filterBy={['razon_social', 'rfc']}
        renderMenuItemChildren={(option) => (
          <div
            key={option.id}
            className="p-2"
          >
            <AvatarLetter
              className="rounded-circle"
              alt={option.rfc}
              title={option.razon_social}
              style={{
                height: '30px',
                marginRight: '10px',
                width: '30px',
              }}
            />
            <span>{option.razon_social}</span>
            <br />
            <span>{option.rfc}</span>

            {option?.sector_primario_is_adquiriente && (
              <>
                <br />
                <span className="badge badge-primary">adquiriente</span>
              </>
            )}

            {option?.sector_primario_is_productor && (
              <>
                <br />
                <span className="badge badge-primary">productor</span>
              </>
            )}
          </div>
        )}
        onSelect={this.handleOnSelect}
      />
    );
  }
}

const mapState = (store) => {
  return { suggestions: store.app.emisores.suggestions };
};

const mapActions = (actions) => {
  return { suggestionsActions: actions.app.emisores.suggestions };
};

export default connect(useStore, mapState, mapActions)(EmisorSuggestionsList);
